import { ArrowUpDown } from "lucide-react";
import { TableHead } from "@/components/ui/table";

const SortableHead = ({
  field,
  label,
  sortField,
  sortDir,
  onSort,
  className,
}) => {
  const active = sortField === field;
  return (
    <TableHead
      className={`cursor-pointer select-none hover:bg-muted/50 ${className ?? ""}`}
      onClick={() => onSort(field)}
    >
      <div className="flex items-center gap-1">
        {label}
        <span
          className={`ml-0.5 ${active ? "text-foreground" : "text-muted-foreground/40"}`}
        >
          {active && sortDir === "asc" ? (
            "↑"
          ) : active && sortDir === "desc" ? (
            "↓"
          ) : (
            <ArrowUpDown className="h-3 w-3" />
          )}
        </span>
      </div>
    </TableHead>
  );
};

export default SortableHead;
